import { useState } from "react";

import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { formatterWithCopy } from "utils/tables-utils";
import { columnTextField } from "utils/tables-utils";

import componentStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";

import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);

const getTableColumns = (searching, selectedDocument, toggleCreateForm) => [
  columnTextField({
    dataField: "remover",
    text: "",
    isDummyField: true,
    headerStyle: { width: "5%" },
    formatter: (_, row) =>
      searching ? null : (
        <Tooltip title="Excluir arquivo">
          <IconButton
            aria-label="remover"
            onClick={() => {
              console.log("linha: ", row);
              selectedDocument(row);
              toggleCreateForm(() => toggleCreateForm("remove"));
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ),
  }),
  columnTextField({
    dataField: "Titulo",
    text: "Título",
    sort: false,
    formatter: (document) => {
      return searching ? (
        <Skeleton variant="text" />
      ) : (
        <Tooltip title={document}>
          <div
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              width: 250,
              overflow: "hidden",
            }}
          >
            <span>{document || "-"}</span>
          </div>
        </Tooltip>
      );
    },
  }),
  columnTextField({
    dataField: "UrlArquivo",
    text: "Link do Vídeo",
    formatter: (_, row) => formatterWithCopy(row["UrlArquivo"]),
  }),
  columnTextField({
    dataField: "DataInclusaoFormat",
    text: "Data Criação",
    sort: false,
    formatter: (document) =>
      searching ? <Skeleton variant="text" /> : document,
  }),
];

export default function TableGerarLinkAWS({
  dataTable,
  totalRegistros,
  currentPage,
  currentSizePerPage,
  toggleCreateForm,
  search,
  searching,
  selectedDocument,
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const isMobile = IsMobile();

  const doSearch = async (page, sizePerPage) => {
    setLoading(true);

    try {
      await search({ page, sizePerPage });
    } catch (error) {
      console.error("Error searching:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page, sizePerPage) => {
    doSearch(page, sizePerPage);
  };

  const handleSizePerPageChange = (sizePerPage, page) => {
    doSearch(page, sizePerPage);
  };

  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="IdMenu"
      dataTable={dataTable}
      columnModel={getTableColumns(
        searching,
        selectedDocument,
        toggleCreateForm
      )}
      headerTitle="Link AWS Gerados"
      showSearch={false}
      loading={loading}
      pagination={{
        options: [25, 50, 100],
        defaultOption: currentSizePerPage,
        totalSize: totalRegistros,
        showTotal: true,
        page: currentPage,
        onPageChange: handlePageChange,
        sizePerPage: currentSizePerPage,
        onSizePerPageChange: handleSizePerPageChange,
      }}
      allowEmpty
      noResultTitle="Sua pesquisa não localizou links cadastrados."
      bootstrapTableProps={{
        remote: true,
        onTableChange: () => {},
      }}
      noResultSubtitle="Verifique os filtros utilizados e tente novamente."
      CustomHeader={() => (
        <Grid
          container
          className="pl-4"
          style={{
            padding: isMobile ? "0" : "0 24px",
            display: "flex",
            alignItems: isMobile ? "flex-start" : "center",
            flexDirection: isMobile ? "column" : "row",
            marginBottom: !isMobile && "1rem",
          }}
        >
          <Grid
            item
            xs={isMobile ? 12 : 6}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Typography variant="h3" marginBottom="0!important">
              <Box component="span">Link AWS Gerados</Box>
              <Tooltip title="Recarregar lista">
                <IconButton
                  onClick={() =>
                    search({
                      page: currentPage,
                      sizePerPage: currentSizePerPage,
                    })
                  }
                >
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </Typography>
          </Grid>
          <Grid
            item
            xs={isMobile ? 12 : 6}
            sm={isMobile ? 12 : 6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              padding: 0,
              marginTop: isMobile && "1rem",
              marginBottom: isMobile ? "1rem" : "0.5rem!important",
            }}
          >
            <Box
              justifyContent={isMobile ? "flex-start" : "flex-end"}
              alignItems="center"
              display="flex"
              flexWrap="wrap"
              style={{
                marginLeft: isMobile ? 10 : 15,
                marginRight: isMobile ? 5 : 15,
                cursor: "pointer",
              }}
            >
              <Button
                variant="contained"
                classes={{
                  root: classes.buttonRootWhite,
                }}
                onClick={() => toggleCreateForm("create")}
                disabled={searching}
                style={{ marginRight: "1rem" }}
              >
                <AddIcon style={{ position: "relative", top: "-2px" }} />{" "}
                Inserir
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}
    />
  );
}
